module.exports = __webpack_public_path__ + "img/work3.0074412e.gif";